import snakecaseKeys from 'snakecase-keys';
import Config from '@/config';
import { API_PREFIX, ENDPOINTS } from '@/services/engine/endpoints';
import { HttpClient } from '@/services/http-client';

let refreshInFlight: Promise<void> | null = null;

export function getPendingEngineSessionRefresh(): Promise<void> | null {
    return refreshInFlight;
}

// Concurrent 401s from the engine and viinex clients share one refresh.
export function refreshEngineSession(): Promise<void> {
    refreshInFlight ??= engineClient
        .post<void>(`${API_PREFIX}${ENDPOINTS.auth}/refresh`, undefined, {
            skipAuthRefresh: true,
            skipAuthRedirect: true,
        })
        .finally(() => {
            refreshInFlight = null;
        });
    return refreshInFlight;
}

export const engineClient = new HttpClient({
    baseURL: () => Config.VITE_ENGINE_URL,
    refreshSession: refreshEngineSession,
    pendingSessionRefresh: getPendingEngineSessionRefresh,
    transformParams: (params) => snakecaseKeys(params),
});
